import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  IconButton,
  TextField,
} from "@mui/material";
import { FaTimes, FaTrash } from "react-icons/fa";
import { notif } from "../../../../utils/util";
import RadioButtonGroup from "../../../../../common/RadioButton";
import { getNDocsM, insertNDocsM } from "../../../../../server/server";

interface NegDocsMeasureModalProps {
  open: boolean;
  onClose: () => void;
  item: any;
}

const NegDocsMeasureModal: React.FC<NegDocsMeasureModalProps> = ({
  open,
  onClose,
  item,
}) => {
  const [toggleState, setToggleState] = useState<boolean | null>(null);
  const [docNames, setDocNames] = useState<string[]>([]);

  const fetchData = async () => {
    if (!item?.id) return;

    const resp = await getNDocsM(item.measureId);

    if (resp?.status === 200) {
      setToggleState(resp?.data?.show ?? null);
      setDocNames(
        resp?.data?.names && resp.data.names.length > 0
          ? resp.data.names
          : [""],
      );
    } else {
      setDocNames([""]);
    }
  };

  useEffect(() => {
    if (open && item?.id) {
      fetchData();
    } else if (!open) {
      setToggleState(null);
      setDocNames([]);
    }
  }, [open, item?.id]);

  const handleToggle = (event: any) => {
    setToggleState(event.target.checked);
  };

  const handleAddDoc = () => {
    setDocNames((prevDocs: string[]) => [...prevDocs, ""]);
  };

  const handleDeleteDoc = (index: number) => {
    setDocNames((prevDocs) => {
      if (index === 0) return prevDocs;
      const newDocs = [...prevDocs];
      newDocs.splice(index, 1);
      return newDocs.length === 0 ? [""] : newDocs;
    });
  };

  const handleDocNameChange = (event: any, index: number) => {
    setDocNames((prevDocs) => {
      const newDocs = [...prevDocs];
      newDocs[index] = event.target.value;
      return newDocs;
    });
  };

  const handleSave = async () => {
    const resp = await insertNDocsM({
      show: toggleState,
      names: docNames,
      measure: { id: item.id },
    });

    if (resp?.status === 201) {
      notif(
        `Веза успешно ${toggleState === null ? "додата" : "ажурирана"}`,
        "success",
      );
      onClose();
    } else {
      notif("Грешка приликом чувања", "error");
    }
  };

  const handleClose = () => {
    setToggleState(null);
    setDocNames([]);
    onClose();
  };

  const isAddDisabled =
    Array.isArray(docNames) &&
    docNames.length > 0 &&
    (docNames[docNames.length - 1] ?? "").trim() === "";

  const requiresNames = toggleState === true || toggleState === null;
  const isSaveDisabled =
    requiresNames &&
    (!Array.isArray(docNames) ||
      docNames.length === 0 ||
      docNames.some((n) => (n ?? "").trim() === ""));

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      disableEnforceFocus
      disableAutoFocus
    >
      <DialogTitle>
        <div className="flex justify-between items-center">
          <span className="text-[#04438b] text-2xl font-bold">
            Преговарачки документи - {item?.measureName}
          </span>
        </div>
      </DialogTitle>
      <DialogContent>
        <div className="pt-4 w-full flex flex-col">
          {/* <p className="text-[#151515] my-4 text-sm">
            Да ли постоји веза са преговарачким документом?
          </p>
          <FormControlLabel
            sx={{ marginLeft: "0px" }}
            control={
              <RadioButtonGroup
                state={toggleState}
                setState={setToggleState}
                isError={false}
                setIsError={() => 1}
                isNoDisabled={false}
              />
            }
            label=""
          /> */}

          {toggleState === true && (
            <div>
              {docNames?.map((name, index) => (
                <div key={index} className="flex items-center my-2 w-full pt-2">
                  <TextField
                    label="Назив преговарачког документа"
                    variant="outlined"
                    value={name}
                    multiline
                    minRows={1}
                    sx={{
                      width: "100%",
                      paddingRight: 2,
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "black",
                        opacity: 1,
                      },
                      "& .MuiInputLabel-root.Mui-disabled": {
                        color: "black",
                      },
                    }}
                    onChange={(e) => handleDocNameChange(e, index)}
                    disabled
                    inputProps={{
                      style: {
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      },
                    }}
                  />
                  {/* <IconButton
                    onClick={() => handleDeleteDoc(index)}
                    className={`${
                      index === 0 ? "invisible" : ""
                    } text-gray-500 rounded-full w-[40px] h-[40px]`}
                    aria-hidden={index === 0}
                    title={
                      index === 0 ? "Прво поље не може да се обрише" : "Обриши"
                    }
                  >
                    <FaTrash />
                  </IconButton> */}
                </div>
              ))}
              {/* <Button
                color="primary"
                onClick={handleAddDoc}
                disabled={isAddDisabled}
              >
                Додај
              </Button> */}
            </div>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <div className="flex gap-4 p-4">
          <div
            className="border border-[#81848f] hover:bg-[#81848f] hover:text-white cursor-pointer flex items-center justify-center text-base font-semibold rounded-lg w-[150px] h-[55px]"
            onClick={handleClose}
          >
            Затвори
          </div>
          {/* {toggleState !== null && (
            <Button
              sx={{ backgroundColor: "#0F2765" }}
              variant="contained"
              color="primary"
              onClick={handleSave}
              disabled={isSaveDisabled}
            >
              Сачувај
            </Button>
          )} */}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default NegDocsMeasureModal;
